/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Layout from "../../../layout";
import Card from "../../../components/Card";
import BackButton from "../../../components/BackButton";
import httpRequest from "../../../ajax";
import { SectionLoader } from "../../../components/PageLoader";
import { useSelector } from "react-redux";
import InvoiceIcon from "../../../assets/icons/invoice-icon.svg";
import CustomButton from "../../../components/CustomButton";

const InvoiceDetail = () => {
  const { invoiceId } = useParams();
  const history = useHistory();
  const [invoice, setInvoice] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userData } = useSelector((state) => state.auth);
  const [invoiceData, setInvoiceData] = useState({});

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await httpRequest(
          "get",
          `/jobs/invoices/${invoiceId}`
        );

        const responseData = response.data.data;
        setInvoiceData(responseData);

        console.log("Invoice Data from API:", responseData);

        if (response.status && response.data) {
          console.log("Invoice response:", response.data);
          setInvoice(responseData);
        } else {
          setError("Invoice not found");
        }
      } catch (err) {
        console.error("Failed to fetch invoice:", err);
        setError("Failed to load invoice details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceDetails();
  }, [invoiceId]);

  useEffect(() => {
    console.log("Invoice state updated:", invoice);
  }, [invoice]);

  useEffect(() => {
    console.log("InvoiceData state updated:", invoiceData);
  }, [invoiceData]);

  if (loading) return <SectionLoader />;
  if (error) return <div className="p-4 text-danger">{error}</div>;

  return (
    <Layout>
      <div className="m-3">
        <Card noPadding additionalClass="p-0 mb-4">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                height: "50px",
                padding: "10px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <BackButton />
              <div>
                <img
                  className="rounded-circle"
                  width="80"
                  src={InvoiceIcon}
                  alt="avatar"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <div style={{ textAlign: "left", width: "80%" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: "26px",
                        color: "#121417",
                        fontWeight: "bolder",
                      }}
                    >
                      Invoice Details
                    </h2>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#61758A",
                        fontWeight: "400",
                      }}
                    >
                      View and manage your invoice details.
                    </p>
                  </div>
                  <div>
                    <CustomButton
                      handleClick={async () => {
                        try {
                          const response = await httpRequest(
                            "get",
                            `/jobs/invoices/${invoiceId}/download`,
                            {
                              responseType: "blob", // Ensure we receive binary PDF
                            }
                          );

                          const blob = new Blob([response.data], {
                            type: "application/pdf",
                          });
                          const url = window.URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = `Invoice-${invoiceId}.pdf`;
                          document.body.appendChild(a);
                          a.click();
                          window.URL.revokeObjectURL(url);
                          a.remove();
                        } catch (error) {
                          console.error("Failed to download invoice:", error);
                          alert(
                            "Failed to download invoice. Please try again later."
                          );
                        }
                      }}
                      text="Download Invoice"
                      backgroundColor="#2C2C2C"
                      color="#F5F5F5"
                      style={{ fontSize: "10px", fontWeight: "400" }}
                    />
                  </div>
                </div>
                {Object.keys(invoiceData).length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      marginTop: "20px",
                    }}
                  >
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Job ID
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.job_id}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "19px",
                        }}
                      >
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Invoice Number
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.invoice_number || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Amount
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {`${invoice.currency} ${invoice.amount}`}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "50px",
                        }}
                      >
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Percentage
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.percentage}
                        </p>
                      </div>
                    </div>
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Invoice Type
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.payment_type || "N/A"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "77px",
                        }}
                      >
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Status
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.status}
                        </p>
                      </div>
                    </div>
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Locked Until
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.locked_until || "N/A"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "25px",
                        }}
                      >
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Estimated Salary
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.estimated_salary || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Transaction ID
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.transaction_id || "N/A"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginRight: "-10px",
                        }}
                      >
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Created At
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.created_at || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div
                      className="border-top border-gray-200 pt-1 mt-2"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#61758A", fontSize: "10px" }}>
                          Updated At
                        </span>
                        <p style={{ color: "#121417", fontSize: "12px" }}>
                          {invoice.updated_at || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="p-4">No invoice data found</div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default InvoiceDetail;
